import React from 'react';
import styled from 'styled-components';

const PanningContainer = styled.section`
  width: 100%;
  height: 100vh;
  min-height: 700px;
  background-size: cover !important;
  background: url('/assets/images/huge-banner-panning.jpg') repeat 0 0;
  animation: animate-left-to-right 60s linear infinite;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  /* Dark overlay for text readability */
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    background: ${props => props.theme.colors.background.overlay};
    opacity: 0.6;
    z-index: 1;
  }
`;

const ContentWrapper = styled.div`
  z-index: 2;
  text-align: center;
  width: 100%;
  max-width: 700px;
  padding: 0 ${props => props.theme.spacing.large};
`;

const Title = styled.h3`
  font-size: 3rem;
  margin: 0 0 ${props => props.theme.spacing.large};
  color: ${props => props.theme.colors.text.primary};
  font-weight: ${props => props.theme.fontWeights.bold};
  text-transform: uppercase;
  letter-spacing: 2px;

  background: linear-gradient(
    135deg,
    ${props => props.theme.colors.primary} 0%,
    ${props => props.theme.colors.neon.cyan} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    font-size: 2.5rem;
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  font-size: ${props => props.theme.fontSizes.xlarge};
  color: ${props => props.theme.colors.text.primary};
  margin-bottom: ${props => props.theme.spacing.xlarge};
  line-height: 1.8;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    font-size: ${props => props.theme.fontSizes.large};
  }
`;

const CTAButton = styled.a`
  display: inline-block;
  padding: ${props => props.theme.spacing.medium} ${props => props.theme.spacing.xxlarge};
  font-size: ${props => props.theme.fontSizes.large};
  font-weight: ${props => props.theme.fontWeights.semibold};
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: ${props => props.theme.borderRadius.medium};
  background: linear-gradient(
    135deg,
    ${props => props.theme.colors.primary} 0%,
    ${props => props.theme.colors.primaryDark} 100%
  );
  color: ${props => props.theme.colors.background.primary};
  box-shadow: ${props => props.theme.shadows.glow};
  transition: all ${props => props.theme.transitions.medium};
  cursor: pointer;

  &:hover {
    transform: translateY(-3px);
    box-shadow: ${props => props.theme.shadows.glowStrong};
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    padding: ${props => props.theme.spacing.small} ${props => props.theme.spacing.large};
    font-size: ${props => props.theme.fontSizes.medium};
  }
`;

const PanningSection: React.FC = () => {
  return (
    <PanningContainer>
      <ContentWrapper>
        <Title>NeuralPrompt App</Title>
        <Description>
          NEURALPROMPT is a powerful prompt editing tool designed to simplify
          the preparation of prompts and scripts intended for use with Midjourney
          on Discord client.
        </Description>
      </ContentWrapper>
    </PanningContainer>
  );
};

export default PanningSection;
